import { render, staticRenderFns } from "./ChangePW.vue?vue&type=template&id=61328a7a&scoped=true"
import script from "./ChangePW.vue?vue&type=script&lang=js"
export * from "./ChangePW.vue?vue&type=script&lang=js"
import style0 from "./ChangePW.vue?vue&type=style&index=0&id=61328a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61328a7a",
  null
  
)

export default component.exports